<template>
  <v-container>
    <v-card align="center" justify="center">
      <template v-if="shouldSeeCard">
        <CardWithButtons :gameId="gameId" :playerKey="playerKey" />
      </template>
      <template v-else>
        <template v-if="turnOngoing">
          It's <b>{{ currentPlayer.player }}</b>'s turn
        </template>
        <template v-else>
          Waiting on <b>{{ currentPlayer.player }}</b>...
        </template>
        <v-divider />
        <CurrentTurnWords :gameId="gameId" />
      </template>
    </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
import CardWithButtons from "./CardWithButtons.vue";
import CurrentTurnWords from "./CurrentTurnWords";
import refs from "./firebase/refs";

export default {
  name: "NonCurrentPlayerView",
  props: {
    gameId: String,
    playerKey: String,
    currentPlayer: Object,
  },
  components: {
    CardWithButtons,
    CurrentTurnWords,
  },
  created() {
    this.listenForTimer();
  },
  methods: {
    listenForTimer() {
      refs.timer(this.gameId).on("value", (snapshot) => {
        if (snapshot.val()) {
          console.log("value exists");
          this.turnOngoing = true;
        } else {
          console.log("value does not exist");
          this.turnOngoing = false;
        }
      });
    },
  },
  data() {
    return {
      turnOngoing: false,
      shouldSeeCard: false
    };
  },
};
</script>
